import React from 'react';
import {
    blueColumn,
    borderBottom,
    centerText,
    centerTextLeft,
    column,
    columnStructure,
    lightColumn,
    row,
    yellowColumn,
} from "../../../../styles";
import {columnRoot} from "./styles";


export interface ColumnProps {
    variant?: "blue" | "lightblue" | "yellow";
    name: React.ReactNode;
    icon: React.ReactNode;
    value: React.ReactNode;
}

export const Column: React.FC<ColumnProps> = ({
    variant ,
    name,
    icon,
    value,
}) => {
    const blue = variant === "blue";
    const lightblue = variant === "lightblue";
    const yellow = variant === "yellow";


    return (
        <div css={column}>
            <div css={[row,
                borderBottom,
                columnRoot,
                blue && blueColumn,
                lightblue && lightColumn,
                yellow && yellowColumn,
            ]}>
                <div css={[columnStructure]}>
                    <div css={row}>
                        <p css={centerTextLeft}>{value}</p>
                        <p style = {{margin: 0}}>µg/m³</p>
                    </div>
                </div>
                <div css={[columnStructure]}>
                    <div css={row}>
                        <p css={centerText}>{name}</p>
                        {icon}
                    </div>
                </div>
            </div>
        </div>
    );
};